import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList, ratioModifierList } from './props-list';

const ASPECT_RATIO_16_10 = '16-10';

const Hero = ({ modifiers, title, abstract, image }) => {
  const classNames = getClassNames('c-hero', modifiers);

  return (
    <div className={classNames}>
      <div className="c-hero__content">
        {title && <h2 className="c-hero__title c-hero__title-content" dangerouslySetInnerHTML={{ __html: title }} />}
        {abstract && <p className="c-hero__abstract" dangerouslySetInnerHTML={{ __html: abstract }} />}
      </div>
      <figure className="c-hero__media-wrapper">
        <div className={`o-aspect-ratio o-aspect-ratio--${image.ratioModifier || ASPECT_RATIO_16_10}`}>
          <img
            className="c-hero__img"
            alt={image.alt}
            src={image.srcDesktop}
            sizes={`(max-width: 1024px) ${image.sizeMobile}, ${image.sizeDesktop}`}
            srcSet={`${image.srcMobile} 768w, ${image.srcDesktop} 1130w`}
          />
        </div>
      </figure>
    </div>
  );
};

Hero.propTypes = {
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  image: PropTypes.shape({
    ratioModifier: PropTypes.oneOf(ratioModifierList),
    alt: PropTypes.string,
    sizeMobile: PropTypes.string.isRequired,
    sizeDesktop: PropTypes.string.isRequired,
    srcMobile: PropTypes.string.isRequired,
    srcDesktop: PropTypes.string.isRequired,
  }),
  title: PropTypes.string,
  abstract: PropTypes.string,
};

export default Hero;
